import React, { useContext } from 'react';
import { ApkContext, IApkContext } from 'modules/FirmwareAndApp/Apk/Apk/apkState/apkContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, apk } = useContext<IApkContext>(ApkContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={apk.count ? 800 : undefined}
		/>
	);
};

export default Search;
